
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Certified Excellence',
      description: 'All our products meet international safety standards and certifications for maximum reliability.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Round-the-clock emergency response and technical support whenever you need us.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Expert Installation',
      description: 'Professional installation and maintenance services by certified technicians.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Best value solutions without compromising on quality or safety standards.'
    },
    {
      icon: 'ri-time-line',
      title: 'Quick Response',
      description: 'Fast delivery and installation to minimize downtime and ensure rapid protection.'
    },
    {
      icon: 'ri-award-line',
      title: '15+ Years Experience',
      description: 'Proven track record with hundreds of successful fire safety installations.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6">
            Why Choose FlameGuardQA?
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We combine cutting-edge technology, expert knowledge, and unwavering commitment 
            to deliver the most reliable fire safety solutions in the industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl card-hover group"
            >
              <div className="w-16 h-16 bg-brand-gradient rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-brand-blue mb-4 group-hover:text-brand-red transition-colors duration-300">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-brand-blue rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-brand-red mb-2">500+</div>
              <div className="text-white">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-red mb-2">1000+</div>
              <div className="text-white">Happy Clients</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-red mb-2">15+</div>
              <div className="text-white">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-brand-red mb-2">24/7</div>
              <div className="text-white">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
